import { Currency } from '@/core/currency/interfaces';

const IRR: Currency = {
    name: 'Iranian Rial',
    demonym: 'Iranian',
    majorSingle: 'Rial',
    majorPlural: 'Rials',
    codeNumeric: '364',
    symbol: '﷼',
    symbolNative: '﷼',
    minorSingle: 'Dinar',
    minorPlural: 'Dinars',
    ISOdigits: 2,
    decimals: 2,
    numToBasic: 100,
    code: 'IRR',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default IRR;
